// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"c170b297","935":"c170b297"}[chunkId] + ".chunk.css";
};